import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { Outlet, Navigate } from "react-router-dom";
import AuthProvider from "../../services/AuthProvider";
export const PrivateRoutes = () => {
    const [token] = useState(AuthProvider.getAuthToken());
    return _jsx(_Fragment, { children: token ? _jsx(Outlet, {}) : _jsx(Navigate, { to: "/login" }) });
};
